module.exports = __webpack_public_path__ + "img/16.02304702.png";